import { Stack, Typography } from "~/common/mui";
import { useTranslation } from "react-i18next";

interface OrderLineInfoProps {
  lineNo: string | number;
  quoteNumber?: string | number;
}

export const OrderLineInfoV2: React.FC<OrderLineInfoProps> = ({ lineNo, quoteNumber }) => {
  const { t } = useTranslation();
  return (
    <Stack direction={"row"} gap={1} alignItems={"center"}>
      <Typography color="text.label">{t("orderDetails.order.line.no")}</Typography>
      <Typography color="text.secondary">{lineNo}</Typography>

      {quoteNumber && (
        <Typography variant="bodySmall" color="text.label" marginLeft={1}>
          {t("orderDetails.quote.line.no", { quoteNumber })}
        </Typography>
      )}
    </Stack>
  );
};
